/**
 * 사업자 정보 — 단일 소스.
 *
 * 전자상거래법 제10조는 상호·대표자·주소·전화번호·이메일·사업자등록번호·
 * 통신판매업신고번호를 초기화면에 표시하도록 정한다. 푸터와 약관 문서가 각자
 * 값을 들고 있으면 반드시 갈라지므로 여기 한 곳에만 둔다.
 *
 * 값 출처: 사업자등록증(2026.03.31 발급, 북대전세무서).
 * TODO 로 남은 항목은 등록증에 없는 정보다 — 확인 후 채워야 공개할 수 있다.
 */
export const COMPANY = {
  /** 서비스 브랜드. 법인명과 다르다 */
  serviceName: '오톱',
  legalName: '주식회사 이더라',
  ceo: '배윤혁',
  businessNumber: '314-88-03281',
  /** TODO: 통신판매업 신고 후 신고번호를 채운다. 미기재 상태로 판매하면 위법이다 */
  mailOrderNumber: null as string | null,
  address: '대전광역시 대덕구 한남로88번길 27, 2층',
  /** TODO: 고객센터 대표번호 확정 후 기재 */
  phone: null as string | null,
  email: 'support@autop.kr',
  /**
   * 개인정보 보호책임자 (개인정보보호법 제31조).
   *
   * 지정하지 않아도 법 제31조 제2항에 따라 대표자가 자동으로 책임자가 된다.
   * 제30조는 **성명·부서·연락처를 개인정보처리방침에 공개**하도록 정하므로 여기에 둔다.
   */
  privacyOfficer: {
    name: '배윤혁',
    title: 'CEO',
    phone: '070-8983-4395',
    email: 'ceo@ideola.co.kr',
  },
  establishedAt: '2024년 7월 15일',
  businessType: '정보통신업 · 응용 소프트웨어 개발 및 공급업',
} as const;

/** 표기가 확정되지 않은 항목은 "확인 중"으로 드러낸다. 빈칸으로 두면 누락이 안 보인다. */
export function displayOrPending(value: string | null): string {
  return value ?? '확인 중';
}
